import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { ServiceList } from 'types/api'
import type { BaseResponse } from 'types/utils'

export const servicesQueryKey = ['services'] as const

type UseServiceArgs = {
  search: string
}

export function useServices({ search }: UseServiceArgs) {
  const queryKey = ['services', search]

  async function getServices() {
    const params = new URLSearchParams()
    params.set('limit', '-1')
    if (search?.trim()) {
      params.set('search', search.trim())
    }

    const response = await apiClient.get<BaseResponse<ServiceList>>(
      SNA_PREFIX + `services?${params.toString()}`
    )
    return response.data.results
  }

  return useQuery({
    queryKey,
    queryFn: getServices
  })
}
